const actions = {
  MESSAGES_COUNT: "MESSAGES_COUNT",
  MESSAGES_RESET: "MESSAGES_RESET",
  MESSAGES_UPDATE: "MESSAGES_UPDATE",
  UNREAD_MESSAGES_UPDATE: "UNREAD_MESSAGES_UPDATE",
};

export default actions